import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotJobSearch = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotJobSearch"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M64.73 58.98 53.99 48.75c3.61-4.91 5.57-10.82 5.57-17.03 0-7.7-3-14.94-8.44-20.38C45.68 5.89 38.44 2.9 30.74 2.9s-14.94 3-20.38 8.44C-.9 22.57-.9 40.86 10.34 52.1c5.45 5.45 12.68 8.44 20.38 8.44 6.34 0 12.36-2.03 17.33-5.79l10.23 10.74c.89.89 2.07 1.34 3.24 1.34s2.35-.45 3.24-1.34c.87-.87 1.34-2.02 1.34-3.24s-.48-2.38-1.38-3.28z"
      />
      <path
        fill="#B7E854"
        d="M30.73 58.55c14.818 0 26.83-12.012 26.83-26.83S45.548 4.89 30.73 4.89 3.9 16.902 3.9 31.72s12.012 26.83 26.83 26.83"
      />
      <path
        fill="#fff"
        d="M30.73 54.12c12.371 0 22.4-10.029 22.4-22.4s-10.029-22.4-22.4-22.4-22.4 10.029-22.4 22.4 10.029 22.4 22.4 22.4"
      />
      <path
        fill="#27DBA8"
        d="M44.76 27.53c0 2.57-2.08 4.65-4.64 4.65H21.41a4.64 4.64 0 0 1-4.65-4.64v-5.78h28z"
      />
      <path
        fill="#27DBA8"
        fillRule="evenodd"
        d="M63.35 60.43 51.3 48.94c-.5.6-1.03 1.18-1.59 1.75-.48.48-.97.92-1.47 1.35l11.47 12.03a2.577 2.577 0 0 0 3.65 0 2.577 2.577 0 0 0 0-3.65z"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M30.73 54.61c-5.86 0-11.73-2.23-16.19-6.7-4.33-4.33-6.71-10.08-6.71-16.19s2.38-11.87 6.71-16.19c4.33-4.33 10.08-6.71 16.19-6.71s11.87 2.38 16.19 6.71c4.33 4.33 6.71 10.08 6.71 16.19s-2.38 11.87-6.71 16.19a22.84 22.84 0 0 1-16.19 6.7m0-44.79c-5.85 0-11.35 2.28-15.49 6.42s-6.42 9.64-6.42 15.49 2.28 11.35 6.42 15.49c8.54 8.54 22.43 8.54 30.97 0 4.14-4.14 6.42-9.64 6.42-15.49s-2.28-11.35-6.42-15.49-9.64-6.42-15.49-6.42z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M45.26 27.54v-6.28h-5.68V21c0-2.33-1.9-4.23-4.23-4.23h-9.16c-2.33 0-4.23 1.9-4.23 4.23v.27h-5.71v21.85h29V27.54zm-6.21 1.94c-.28 0-.5.22-.5.5v1.7H22.99v-1.7c0-.28-.22-.5-.5-.5s-.5.22-.5.5v1.7h-.57a4.15 4.15 0 0 1-4.15-4.14v-5.28h4.71v1.45h1v-1.45h15.61v1.45h1v-1.46h4.68v5.28c0 2.28-1.86 4.14-4.14 4.14h-.57v-1.7c0-.28-.22-.5-.5-.5zm-16.08-8.49c0-1.78 1.45-3.23 3.23-3.23h9.16c1.78 0 3.23 1.45 3.23 3.23v.26H22.98v-.26zm-5.7 9.57c.94 1.28 2.44 2.12 4.15 2.12h.57v1.83c0 .28.22.5.5.5s.5-.22.5-.5v-1.83h15.56v1.83c0 .28.22.5.5.5s.5-.22.5-.5v-1.83h.57c1.71 0 3.21-.84 4.15-2.13V42.1H17.28V30.55z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M63.71 60.07 51.98 48.9c3.94-4.85 6.08-10.85 6.08-17.18 0-7.3-2.84-14.16-8-19.32-10.66-10.66-28-10.66-38.65-.01C6.24 17.56 3.4 24.42 3.4 31.72s2.84 14.16 8 19.32 12.02 8 19.32 8c6.46 0 12.57-2.23 17.47-6.31l11.15 11.7c.6.6 1.39.9 2.18.9a3.073 3.073 0 0 0 3.08-3.08c0-.82-.32-1.6-.9-2.18zm-32.98-2.02c-7.03 0-13.64-2.74-18.62-7.71S4.4 38.76 4.4 31.72s2.74-13.64 7.71-18.62 11.88-7.7 18.62-7.7 13.48 2.57 18.62 7.7 7.71 11.58 7.71 18.62c0 6.1-2.06 11.87-5.85 16.54l-.3.36q-.405.48-.78.9a20 20 0 0 1-1.51 1.51c-.22.2-.46.41-.72.64l-.4.34c-4.71 3.91-10.58 6.04-16.78 6.04zM63 63.73c-.81.81-2.13.81-2.94 0l-11.1-11.66.38-.35a19.149 19.149 0 0 0 1.47-1.47c.16-.17.32-.35.47-.53l.06-.06 11.67 11.12c.39.39.61.92.61 1.47s-.22 1.08-.61 1.47z"
      />
    </svg>
  );
};
export default IllustrationSpotJobSearch;
